<template>
  <SpinnerContainer :is-loading="isTableLoading">
    <DynamicTableHeightWrapper
      :paginated-table="true"
    >
      <PaginatedTable
        ref="table"
        :selectable="isSelectable"
        :columns="mTableColumnsData"
        sortable
        resizable
        :fit-container="true"
        :fill-container="false"
        :data="data"
        :items-total="itemsTotal"
        :per-page="perPage"
        :enabled-key="enabledKey"
        :selected-ids="selectedItems"
        :current-page="currentPage"
        :color-function="colorFunction"
        :initial-sorting="currentSorting"
        font-size="M"
        :multi-sortable="true"
        @select="$emit('select', $event)"
        @fetch="$emit('fetch', $event)"
        @sort="$emit('sort', $event)"
      />
    </DynamicTableHeightWrapper>
  </SpinnerContainer>
</template>

<script>
  import {PaginatedTable, SpinnerContainer} from '@marilyn/marilyn-ui';
  import DynamicTableHeightWrapper from 'components/Tables/TableCells/DynamicTableHeightWrapper';

  export default {
    name: 'AccountsTable',
    components: {
      DynamicTableHeightWrapper,
      PaginatedTable,
      SpinnerContainer
    },
    props: {
      currentPage: {
        type: Number,
        default: 1
      },
      isTableLoading: {
        type: Boolean,
        default: false
      },
      data: {
        type: Array,
        required: true
      },
      mTableColumnsData: {
        type: Array,
        default: Array,
        required: true
      },
      isSelectable: {
        type: Boolean,
        default: true
      },
      itemsTotal: {
        type: Number,
        required: true
      },
      selectedItems: {
        type: Array,
        required: true
      },
      perPage: {
        type: Number,
        default: 10
      },
      defaultSorting: {
        type: Array,
        default: Array
      },
      enabledKey: {
        type: String,
        default: null
      },
      currentSorting: {
        type: Array,
        default: Array
      }
    },
    data () {
      return {
        colorFunction: (tableRow) => tableRow.status === 'ARCHIVED'
          ? {background: '#EAEAEA', color: '#8D8D8D', linkColor: '#8D8D8D'}
          : {}
      };
    }
  };
</script>
